import React from "react";
import QRCode from 'qrcode.react';
import Modal from '../../common/modal';
import { changeModal, copy } from "../../common/utils";

const Sub = ({ subLink }) => {
    return (
        <>
            <Modal target={"sub"} title={"订阅方式"}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4">
                    <button
                        onClick={() => copy(subLink)}
                        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium py-3 px-4 rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 shadow-sm hover:shadow-md border-0"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                        </svg>
                        <span>复制URL</span>
                    </button>
                    <button
                        onClick={() => { changeModal('qr', true); }}
                        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-purple-500 to-pink-600 text-white font-medium py-3 px-4 rounded-lg hover:from-purple-600 hover:to-pink-700 transition-all duration-300 shadow-sm hover:shadow-md border-0"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v4m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                        </svg>
                        <span>查看二维码</span>
                    </button>
                    <button
                        onClick={() => {
                            let processedSubLink = btoa(subLink + "&flag=shadowrocket");
                            window.location.href = `shadowrocket://add/sub://${processedSubLink}?remark=${encodeURIComponent(process.env.REACT_APP_NAME)}`;
                        }}
                        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-orange-500 to-red-600 text-white font-medium py-3 px-4 rounded-lg hover:from-orange-600 hover:to-red-700 transition-all duration-300 shadow-sm hover:shadow-md border-0"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                        <span>导入Shadowrocket</span>
                    </button>
                    <button
                        onClick={() => {
                            let encodeurl = encodeURIComponent(subLink + "&flag=clash");
                            window.location.href = `clash://install-config?url=${encodeurl}&name=${encodeURIComponent(process.env.REACT_APP_NAME)}`;
                        }}
                        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-medium py-3 px-4 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-300 shadow-sm hover:shadow-md"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                        <span>导入Clash</span>
                    </button>
                    <button
                        onClick={() => {
                            let encodeurl = encodeURIComponent(subLink);
                            window.location.href = `clash://install-config?url=${encodeurl}&name=${encodeURIComponent(process.env.REACT_APP_NAME)}`;
                        }}
                        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-teal-500 to-cyan-600 text-white font-medium py-3 px-4 rounded-lg hover:from-teal-600 hover:to-cyan-700 transition-all duration-300 shadow-sm hover:shadow-md"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                        </svg>
                        <span>导入Clash Meta</span>
                    </button>
                    <button
                        onClick={() => {
                            let encodeurl = encodeURIComponent(subLink);
                            window.location.href = `clash://install-config?url=${encodeurl}&name=${encodeURIComponent(process.env.REACT_APP_NAME)}`;
                        }}
                        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-indigo-500 to-blue-600 text-white font-medium py-3 px-4 rounded-lg hover:from-indigo-600 hover:to-blue-700 transition-all duration-300 shadow-sm hover:shadow-md"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                        </svg>
                        <span>导入Clash Verge</span>
                    </button>
                    <button
                        onClick={() => {
                            let encodeurl = encodeURIComponent(subLink);
                            window.location.href = `clash://install-config?url=${encodeurl}&name=${encodeURIComponent(process.env.REACT_APP_NAME)}`;
                        }}
                        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-yellow-500 to-amber-600 text-white font-medium py-3 px-4 rounded-lg hover:from-yellow-600 hover:to-amber-700 transition-all duration-300 shadow-sm hover:shadow-md"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                        </svg>
                        <span>导入Flclash</span>
                    </button>
                    <button
                        onClick={() => {
                            let encodeurl = encodeURIComponent(subLink);
                            window.location.href = `stash://install-config?url=${encodeurl}`;
                        }}
                        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-pink-500 to-rose-600 text-white font-medium py-3 px-4 rounded-lg hover:from-pink-600 hover:to-rose-700 transition-all duration-300 shadow-sm hover:shadow-md"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                        </svg>
                        <span>导入Stash</span>
                    </button>
                    <button
                        onClick={() => {
                            let encodeurl = encodeURIComponent(subLink + "&flag=singbox#" + process.env.REACT_APP_NAME);
                            window.location.href = `sing-box://import-remote-profile?url=${encodeurl}`;
                        }}
                        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-violet-500 to-purple-600 text-white font-medium py-3 px-4 rounded-lg hover:from-violet-600 hover:to-purple-700 transition-all duration-300 shadow-sm hover:shadow-md"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                        </svg>
                        <span>导入Sing-Box</span>
                    </button>
                    <button
                        onClick={() => {
                            let encodeurl = encodeURIComponent(subLink + "&flag=surge");
                            window.location.href = `surge://install-config?url=${encodeurl}&name=${encodeURIComponent(process.env.REACT_APP_NAME)}`;
                        }}
                        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-sky-500 to-blue-600 text-white font-medium py-3 px-4 rounded-lg hover:from-sky-600 hover:to-blue-700 transition-all duration-300 shadow-sm hover:shadow-md"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
                        </svg>
                        <span>导入Surge</span>
                    </button>
                </div>
            </Modal>
            <Modal target={"qr"} title={"二维码"}>
                <div className="bg-white p-8 rounded-lg relative flex flex-col items-center">
                    <div className="bg-white p-4 rounded-xl shadow-lg">
                        <QRCode
                            value={subLink}
                            size={200}
                            level="H"
                            includeMargin={true}
                            renderAs="svg"
                        />
                    </div>
                    <p className="mt-4 text-sm text-gray-500">扫描二维码即可订阅</p>
                </div>
            </Modal>
        </>
    )
};
export default Sub;